export default "__VITE_ASSET__2760f731__"